module.exports = __webpack_public_path__ + "static/media/status-done.2c50fb68.svg";